export default function ShimmerLoaderAddons() {
  return (
    <div className="w-full max-w-4xl mx-auto bg-white rounded-2xl shadow-lg border border-slate-100 p-6 animate-pulse font-sans">
      {/* Header Section */}
      <div className="flex items-start justify-between pb-4">
        <div className="space-y-2">
          {/* Title */}
          <div className="h-6 w-64 bg-slate-200 rounded-md" />
          {/* Subtitle (Date / Guests) */}
          <div className="h-4 w-32 bg-slate-200 rounded-md" />
        </div>
        {/* Close Icon */}
        <div className="h-6 w-6 bg-slate-200 rounded-md" />
      </div>
      {/* Tabs Navigation */}
      <div className="flex gap-8 border-b border-slate-200 mt-2 pb-3">
        <div className="relative">
          <div className="h-4 w-20 bg-slate-200 rounded-md" />
          {/* Active Tab Indicator */}
          <div className="absolute -bottom-3 left-0 right-0 h-1 bg-slate-300 rounded-full" />
        </div>
        <div className="h-4 w-24 bg-slate-200 rounded-md" />
      </div>
      {/* Filter & Search Controls */}
      <div className="flex flex-wrap items-center justify-between gap-4 my-6">
        {/* Category Dropdown Placeholder */}
        <div className="space-y-1.5">
          <div className="h-3 w-16 bg-slate-200 rounded" />
          <div className="h-10 w-36 bg-slate-200 rounded-xl" />
        </div>
        {/* Search Input & Sort By Placeholder */}
        <div className="flex items-center gap-4 flex-1 justify-end max-w-xl">
          {/* Search Input */}
          <div className="h-10 flex-1 bg-slate-200 rounded-xl" />
          {/* Sort By Dropdown */}
          <div className="h-5 w-20 bg-slate-200 rounded-md" />
        </div>
      </div>
      {/* Activity Cards List */}
      <div className="space-y-4">
        {/* Card 1: Selected State Variant */}
        <div className="p-4 border border-slate-200 rounded-2xl flex flex-col md:flex-row gap-5">
          {/* Thumbnail Image */}
          <div className="w-full md:w-56 h-40 bg-slate-200 rounded-xl flex-shrink-0" />
          {/* Card Details */}
          <div className="flex-1 flex flex-col justify-between">
            <div className="space-y-2.5">
              {/* Title */}
              <div className="h-5 w-3/4 bg-slate-200 rounded-md" />
              {/* Description Lines */}
              <div className="h-3.5 w-full bg-slate-200 rounded" />
              <div className="h-3.5 w-5/6 bg-slate-200 rounded" />
              {/* Tags / Metadata */}
              <div className="pt-2 space-y-2">
                <div className="h-3.5 w-32 bg-slate-200 rounded" />
                <div className="h-3.5 w-52 bg-slate-200 rounded" />
              </div>
            </div>
            {/* Footer Link */}
            <div className="h-3.5 w-20 bg-slate-200 rounded mt-3" />
          </div>
          {/* Right Action Button */}
          <div className="flex md:flex-col justify-end items-end shrink-0 md:self-center">
            <div className="h-10 w-32 bg-slate-200 rounded-xl" />
          </div>
        </div>
        {/* Card 2: Price + Select Button Variant */}
        <div className="p-4 border border-slate-200 rounded-2xl flex flex-col md:flex-row gap-5">
          {/* Thumbnail Image */}
          <div className="w-full md:w-56 h-40 bg-slate-200 rounded-xl flex-shrink-0" />
          {/* Card Details */}
          <div className="flex-1 flex flex-col justify-between">
            <div className="space-y-2.5">
              {/* Title */}
              <div className="h-5 w-3/4 bg-slate-200 rounded-md" />
              {/* Description Lines */}
              <div className="h-3.5 w-full bg-slate-200 rounded" />
              <div className="h-3.5 w-4/5 bg-slate-200 rounded" />
              {/* Tags / Metadata */}
              <div className="pt-2 space-y-2">
                <div className="h-3.5 w-32 bg-slate-200 rounded" />
                <div className="h-3.5 w-52 bg-slate-200 rounded" />
              </div>
            </div>
          </div>
          {/* Right Action (Price & Button) */}
          <div className="flex flex-col justify-between items-end shrink-0 pt-2 md:pt-0">
            <div className="space-y-1 text-right">
              <div className="h-5 w-24 bg-slate-200 rounded-md ml-auto" />
              <div className="h-3 w-16 bg-slate-200 rounded ml-auto" />
            </div>
            <div className="h-10 w-28 bg-slate-200 rounded-xl mt-4" />
          </div>
        </div>
      </div>
    </div>
  );
}